import { useEffect, useState } from 'react';
import axios from 'axios';

const apiUrl = 'https://elcobradorleague.com/api';

export const useArmyboard = (idleague) => {
  const [factions, setFactions] = useState([]);

  useEffect(() => {
    if (!idleague) return;

    const controller = new AbortController();

    axios.get(
      `${apiUrl}/api.php?endpoint=armyboard&idleague=${idleague}`,
      {
        headers: {
          'X-API-TOKEN': process.env.REACT_APP_API_TOKEN
        },
        signal: controller.signal
      }
    )
    .then(res => {
      if (!Array.isArray(res.data)) {
        setFactions([]);
        return;
      }

      const grouped = res.data.reduce((acc, army) => {
        if (!acc[army.faction]) {
          acc[army.faction] = { faction: army.faction, armies: [] };
        }
        acc[army.faction].armies.push(army);
        return acc;
      }, {});

      setFactions(Object.values(grouped));
    })
    .catch(err => {
      if (err.name !== 'CanceledError') {
        setFactions([]);
      }
    });

    return () => controller.abort();
  }, [idleague]);

  return { factions };
};
